<div class="schedule-progress-container" [ngClass]="{ vertical: orientation() === 'vertical', horizontal: orientation() === 'horizontal' }">
	@for (step of schedulerSteps(); track step.id; let last = $last) {
		<md-stepper-step
			[orientation]="orientation()"
			(click)="isStepComplete(step)() && !isAllStepsComplete() && goToStep(step)"
			[ngClass]="{ 'scheduler-step-complete': isStepComplete(step)() }"
			[step]="step"
			[isActive]="isStepActive(step)()"
			[isComplete]="isStepComplete(step)()"
			[isLastStep]="last"
		></md-stepper-step>
	}
</div>
